import * as cartApi from '../../helpers/cartApi';

const selectors = {
  quantityIncrement: '[data-quantity-increment]',
  quantityDecrement: '[data-quantity-decrement]',
  quantityInput: '[data-quantity-input]',
  removeItemButton: '[data-cart-remove]',
  itemError: '[data-item-error]',
};

/**
 * The wrapper class for Cart items
 *
 * @export
 * @class CartItem
 */
export default class CartItem {
  constructor(el, updateCart) {
    this.el = el;
    this.updateCart = updateCart;

    this._init();
  }

  _init = () => {
    this.quantityIncrement = this.el.querySelector(selectors.quantityIncrement);
    this.quantityDecrement = this.el.querySelector(selectors.quantityDecrement);
    this.quantityInput = this.el.querySelector(selectors.quantityInput);
    this.removeItemButton = this.el.querySelector(selectors.removeItemButton);
    this.itemError = this.el.querySelector(selectors.itemError);

    this._attachListeners();
  };

  _attachListeners = () => {
    if (this.quantityIncrement) {
      this.quantityIncrement.addEventListener('click', this.incrementQuantity);
    }
    if (this.quantityDecrement) {
      this.quantityDecrement.addEventListener('click', this.decrementQuantity);
    }
    if (this.quantityInput) {
      this.quantityInput.addEventListener('input', this.updateQuantity);
    }
    if (this.removeItemButton) {
      this.removeItemButton.addEventListener('click', this.removeItem);
    }
  };

  incrementQuantity = () => {
    const id = this.el.dataset.cartItem;
    const newQuantity = parseInt(this.quantityInput.value) + 1;
    this.changeAndUpdate(id, newQuantity);
  };

  decrementQuantity = () => {
    const id = this.el.dataset.cartItem;
    const newQuantity = parseInt(this.quantityInput.value) - 1;
    this.changeAndUpdate(id, newQuantity);
  };

  updateQuantity = () => {
    const id = this.el.dataset.cartItem;
    const newQuantity = this.quantityInput.value;
    this.changeAndUpdate(id, newQuantity);
  };

  removeItem = () => {
    const id = this.el.dataset.cartItem;
    this.changeAndUpdate(id, 0);
  };

  showErrorMessage = message => {
    this.itemError.textContent = message;
  };

  // `id` is the line item key: line positions shift when anything else edits the cart
  changeAndUpdate = (id, quantity) => {
    cartApi.change({ id, quantity }).then(res => {
      if (res.sections && !res.error) {
        this.updateCart({ sections: res.sections });
      } else {
        this.showErrorMessage(res.message);
      }
    });
  };
}
